import React from 'react';
import { Card, Grid, Typography } from '@mui/material';
import { connect } from 'react-redux';
import * as common from '../../appRedux/actions/common';
import * as field from '../../appRedux/actions/field';
import IntlMessages from '../../util/IntlMessages';
import Comeback from '../../components/comeback';
import * as tools from '../../util/tools';
import useStyles from './styles';

function Sales(props) {
  const classes = useStyles();
  let data = tools.getSalesContent();

  let onClickFunc = (link) => {
    props.setFields([{ data: [], field: 'list' }]);
    props.redirectAction(link);
  };

  return (
    <React.Fragment>
      <Comeback title={<IntlMessages id="sales" />} />
      <Grid container spacing={4} className={classes.root}>
        {data.map((obj, index) => (
          <Grid item xs={6} md={12} key={index} onClick={() => onClickFunc(obj.link)}>
            <Card
              style={{
                backgroundColor: '#fe5001',
                color: '#fff',
                padding: 5,
                textAlign: 'center',
              }}
            >
              <img
                src={obj.image}
                alt={<IntlMessages id="alt.main" />}
                className={classes.image}
              />
              <Typography className={classes.typography}>{obj.title}</Typography>
            </Card>
          </Grid>
        ))}
      </Grid>
    </React.Fragment>
  );
}

const mapDispatchToProps = (dispatch) => {
  return {
    setFields: (data) => dispatch(field.setFields(data)),
    redirectAction: (data) => dispatch(common.redirectAction(data)),
  };
};

export default connect(null, mapDispatchToProps)(Sales);
